<div *ngIf="isLoading; else elseBlock" class="spinnerModal">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>




  <div *ngIf="dataOrder && !isLoading; else message">
    <h3><i><b>Historial de Cambios</b></i></h3>


    
    <table mat-table [dataSource]="dataOrder" style="width: 100%;" matSort (matSortChange)="announceSortChange($event)"
      class="mat-elevation-z8">

      <!-- Position Column -->
      <ng-container matColumnDef="day">
        <th mat-header-cell class="headerTable" *matHeaderCellDef mat-sort-header
          sortActionDescription="Sort by number">
          DIA
        </th>
        <td mat-cell *matCellDef="let element" > {{element.day}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="nombreServicio">
        <th mat-header-cell class="headerTable" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
          SERVICIO
        </th>
        <td mat-cell *matCellDef="let element" class="bodyTable"> {{element.nombreServicio}} </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="tipoServicio">
        <th mat-header-cell class="headerTable" *matHeaderCellDef mat-sort-header
          sortActionDescription="Sort by weight">
          TIPO SERVICIO
        </th>
        <td mat-cell *matCellDef="let element" class="bodyTable"> {{element.tipoServicio}} </td>
      </ng-container>



      <ng-container matColumnDef="nombreProveedor">
        <th mat-header-cell class="headerTable" *matHeaderCellDef mat-sort-header
          sortActionDescription="Sort by symbol">
          PROVEEDOR
        </th>
        <td mat-cell *matCellDef="let element" class="bodyTable"> {{element.nombreProveedor}} </td>
      </ng-container>

      <ng-container matColumnDef="tipoProveedor">
        <th mat-header-cell class="headerTable" *matHeaderCellDef mat-sort-header
          sortActionDescription="Sort by symbol">
          TIPO PROVEEDOR
        </th>
        <td mat-cell *matCellDef="let element" class="bodyTable"> {{element.tipoProveedor}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <ng-template #message>
    <div style="height: 80%;"
      style="display: flex; justify-content: center;margin: auto;align-items: center; flex-direction: column;">
      <h1>No hay Historial</h1>
      <mat-icon style="font-size: 9rem;">info</mat-icon>
    </div>

  </ng-template>



</ng-template>


<div style="margin-top: 1rem;" class="divCenter">
  <button class="buttonPrimary" (click)="close()">Cerrar</button>
</div>